import script from "./NewApiClientDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewApiClientDialog.vue?vue&type=script&setup=true&lang=js"

import "./NewApiClientDialog.vue?vue&type=style&index=0&id=f99b1c84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f99b1c84"]])

export default __exports__